
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Star, User, MessageSquare } from "lucide-react";

const reviews = [
  {
    name: "Vicki W.",
    rating: 5,
    date: "March 2025",
    review: "Comfortable and quiet. The recent updates are very nice and reflect thoughtful attention to detail. The owner's local recommendations were spot-on and made our stay very enjoyable.",
  },
  {
    name: "Toni B.",
    rating: 5,
    date: "September 2024",
    review: "We loved everything about this property and will stay there again! The kitchen was well-equipped and the beds were very comfortable. Easy walks to the beach and restaurants.",
  },
  {
    name: "Russell J.",
    rating: 5,
    date: "October 2024",
    review: "What a gem! The location is very convenient with great walkability. The condo is very well appointed and exceeded our expectations.",
  },
  {
    name: "Matthew N.",
    rating: 5,
    date: "August 2024",
    review: "This condo was a great fit for me and made for a very peaceful beach getaway!",
  },
  {
    name: "Cindy T.",
    rating: 5,
    date: "June 2024",
    review: "A great place to get off the grid and enjoy time at the beach!",
  }
];

const reviewPlatforms = [
  {
    name: "Airbnb",
    url: "https://www.airbnb.com/rooms/1184156151647820749?source_impression_id=p3_1743368297_P3SD5QLu2TOY5RvR",
    bgColor: "bg-[#FF385C]",
    hoverColor: "hover:bg-[#E31C5F]"
  },
  {
    name: "VRBO",
    url: "https://www.vrbo.com/4066372",
    bgColor: "bg-[#3B4DA3]",
    hoverColor: "hover:bg-[#2C3B8C]"
  },
  {
    name: "Seaside Vacations",
    url: "https://www.outerbanksvacations.com/vacation-rentals/sdv306-beachbreak",
    bgColor: "bg-[#0EA5E9]",
    hoverColor: "hover:bg-[#0284C7]"
  }
];

const Reviews = () => {
  const renderStars = (rating: number) => {
    return [...Array(rating)].map((_, index) => (
      <Star key={index} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
    ));
  };

  return (
    <div className="container mx-auto py-16 px-4">
      <h2 className="text-4xl font-bold text-center mb-12">What Our Guests Say</h2>
      
      {/* Guest Reviews Grid */}
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-16">
        {reviews.map((review, index) => (
          <Card key={index} className="fade-in">
            <CardContent className="pt-6">
              <div className="flex items-start gap-4 mb-4">
                <div className="rounded-full bg-primary/10 p-2">
                  <User className="h-5 w-5 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold">{review.name}</h3>
                  <div className="flex items-center gap-1 mt-1">
                    {renderStars(review.rating)}
                  </div>
                  <p className="text-sm text-muted-foreground mt-1">{review.date}</p>
                </div>
              </div>
              <div className="flex gap-2 items-start">
                <MessageSquare className="h-4 w-4 text-muted-foreground mt-1 flex-shrink-0" />
                <p className="text-muted-foreground">{review.review}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Leave a Review Section */}
      <div className="max-w-2xl mx-auto">
        <span id="ShareReview" className="invisible block h-0"></span>
        <Card className="fade-in">
          <CardHeader>
            <CardTitle className="text-2xl text-center">Share Your Experience</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {reviewPlatforms.map((platform) => (
              <Button
                key={platform.name}
                className={`w-full ${platform.bgColor} ${platform.hoverColor} transition-colors`}
                onClick={() => window.open(platform.url, "_blank")}
              >
                Review on {platform.name}
              </Button>
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Reviews;
